import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ResponseError } from "aws-sdk/clients/ec2";
import { AxiosError } from "axios";
import { QUERY_KEYS } from "constants/queryKeys";
import { Strings } from "constants/translations";
import { errorModal, successModal } from "modules/error/ErrorHandlingModals";
import { postUserService } from "modules/users";

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postUserService,
    mutationKey: [QUERY_KEYS.create_user],
    onSuccess: () => {
      successModal(Strings.account__created__success);
      queryClient.refetchQueries({ queryKey: [QUERY_KEYS.user_list] });
    },
    onError: (error: AxiosError<ResponseError & { errorCode: string; meta: { id: string } }>) => {
      if (error.response?.data?.errorCode !== "USERS_ALREADY_EXISTS") {
        errorModal(error);
      }
    }
  });
};
